import { render, staticRenderFns } from "./CertExpired.vue?vue&type=template&id=27b75a5c&scoped=true"
import script from "./CertExpired.vue?vue&type=script&lang=js"
export * from "./CertExpired.vue?vue&type=script&lang=js"
import style0 from "./CertExpired.vue?vue&type=style&index=0&id=27b75a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b75a5c",
  null
  
)

export default component.exports